module.exports = __webpack_public_path__ + "assets/img/num-01-0989922e.png";